import { TIconName, StatusColor, useRiskColor, useEntityColor } from '../ColoredIconAndChip';
import { EntityStatus } from '@verifime/utils';
import { TStatus } from './types';

export const STATUS_ICON_MAPPING: {
  [status in TStatus]: TIconName;
} = {
  Low: 'checkCircleRounded',
  Medium: 'warningRounded',
  High: 'cancelRounded',
  Extreme: 'blockRounded',
  Pending: 'remove',
  InProgress: 'pending',
  Pass: 'checkCircleRounded',
  Fail: 'cancelRounded',
  Error: 'errorRounded',
  Incomplete: 'pending',
  Expired: 'cancelRounded',
};

/**
 * Hook to get color for a status value
 * Hides internal palette structure from callers
 */
export function useStatusColor(status: TStatus): StatusColor {
  // Map status to appropriate semantic color
  const riskStatuses: Record<string, 'Extreme' | 'High' | 'Medium' | 'Low' | 'Pending'> = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Extreme: 'Extreme',
    Pending: 'Pending',
    Incomplete: 'Extreme',
  };
  
  const entityStatuses: Record<string, EntityStatus> = {
    InProgress: EntityStatus.InProgress,
    Pass: EntityStatus.Verified,
    Fail: EntityStatus.Rejected,
    Error: EntityStatus.Rejected,
    Expired: EntityStatus.Rejected,
  };
  
  // Both hooks are called unconditionally on every render (react-hooks/rules-of-hooks):
  // useRiskColor and useEntityColor are each just useTheme() plus a plain lookup (see
  // ColoredIconAndChip/constants.ts), so calling both and discarding the one that does not apply
  // to this status has no side effect and no meaningful cost.
  const riskColor = useRiskColor(riskStatuses[status]);
  const entityColor = useEntityColor(entityStatuses[status]);

  return status in riskStatuses ? riskColor : entityColor;
}
